export const generalKey = 'product_bk621';
export const generalKey_1 = 'product_bk621';
export const generalKey_2 = 'product_bk622';
export const generalKey_3 = 'product_bk623';
export const generalKey_4 = 'smart_plug_shell_de';
export const generalKey_5 = 'product_sm003';
export const generalKey_6 = 'product_bk621_ultra_spu';
export const whiteLocaleList = ['eu', 'fr', 'es', 'uk', 'it', 'de']; //白名单
export const productPageUrl = 'stream-series-plug-in-solar-battery';
export const tabsValues = ['Product', 'Bundles', 'Specs', 'FAQ'];
export const productPageTheme = 'white'; //主题色
export const productGeneralObjA: any = {
    stream: generalKey_1,
    streamUltra: generalKey_2,
    streamAcPro: generalKey_3,
};

// specs&support共用generalKey
export const generalKeys = [
    {
        key: 'product_bk621_ultra_spu',
        url: 'stream-ultra',
    },
    {
        key: 'product_bk621',
        url: 'stream-pro',
    },
    {
        key: 'product_bk623',
        url: 'stream-ac-pro',
    },
    {
        key: 'product_bk625',
        url: 'stream-ac',
    },
    {
        key: 'product_bk624',
        url: 'stream-max',
    },
];
